// name, lat, lng, minZoom, maxZoom

const berlin = [
  ['Mitte', 52.531658, 13.359605, 0, 20],
  ['Friedrichshain-Kreuzberg', 52.504438, 13.405846, 6, 20],
  ['Pankow', 52.590782,13.426418, 6, 20],
  ['Charlottenburg-Wilmersdorf', 52.500851, 13.238246, 0, 20],
  ['Spandau', 52.538390, 13.169292, 6, 20],
  ['Steglitz-Zehlendorf', 52.449815, 13.234452, 6, 20],
  ['Tempelhof-Schöneberg', 52.458516,13.369986, 0, 20],
  ['Neukölln', 52.467277, 13.431979, 6, 20],
  ['Treptow-Köpenick', 52.444187, 13.580461, 0, 20],
  ['Marzahn-Hellersdorf', 52.529560, 13.557446, 6, 20],
  ['Lichtenberg', 52.529500, 13.468593, 0, 20],
  ['Reinickendorf', 52.594967, 13.255966, 0, 20]
];

const germany = [
  ['Hamburg', 53.5584902,9.7877416, 6, 20],
  ['Düsseldorf', 51.2384339,6.7443112, 6, 20],
  ['Stuttgart', 48.7791878,9.1071762, 6, 20],
  ['München', 48.1548895,11.4717967, 6, 20],
  ['Kiel', 54.3417926,10.0556381, 6, 20],
  ['Mainz', 49.9653659,8.1724916, 0, 20],
  ['Saarbrücken', 49.2471361,6.9124993, 0, 20],
  ['Erfurt', 50.9853195,10.9452965, 6, 20],
  ['Dresden', 51.0768128,13.7025467, 6, 20],
  ['Magdeburg', 52.1259454,11.571798, 6, 20],
  ['Bremen', 53.1199492,8.5962058, 6, 20],
  ['Schwerin', 53.615894,11.3307936, 0, 20],
  ['Potsdam', 52.4283409,12.9573733, 0, 20],
  ['Hannover', 52.3796457,9.6914325, 0, 20],
  ['Berlin', 52.5067614,13.2846517, 6, 20]
];

const thueringen = [
  ['Erfurt', 50.9806204,11.0268643, 0, 20],
  ['Nordhausen', 51.4741127,10.7595783, 10, 20],
  ['Eisenach', 50.9837854,10.3103343, 0, 20],
  ['Gera', 50.8821704,12.0723133, 0, 20],
  ['Altenburg', 50.9881824,12.4246393, 0, 20],
  ['Suhl', 50.6103764,10.6682563, 0, 20],
  ['Weimar', 50.9791154,11.3111193, 10, 20],
  ['Jena', 50.9276764,11.5697143, 0, 20],
  ['Gotha', 50.9448824,10.6735773, 8, 20],
  ['Ilmenau', 50.6887994,10.9014223, 8, 20],
  ['Heiligenstadt', 51.3702275,10.1426391, 8, 20],
  ['Sonderhausen', 51.3526268,10.6441755, 8, 20],
  ['Sömmerda', 51.1728267,11.0693319, 8, 20],
  ['Rudolstadt', 50.7076546,11.2256692, 0, 20],
  ['Meiningen', 50.5762977,10.3759493, 8, 20],
  ['Remptendorf', 50.5422712,11.5250158, 0, 20],
  ['Hildburghausen', 50.4372995,10.6652158, 0, 20],
  ['Bad Salzungen', 50.7908345,10.1819484, 8, 20],
  ['Langenwetzendorf', 50.6660903,12.0270899, 8, 20],
  ['Stadtroda', 50.8607233,11.7020395, 8, 20],
  ['Sonneberg', 50.3675115,11.1024225, 8, 20],
  ['Neumark', 51.0894925,11.235478, 6, 20],
  ['Mülhausen', 51.2389409,10.3888035,0,20]
];

const germanStates = [
  ['Baden-Württemberg', 48.832237, 8.602314, 0, 20],
  ['Bayern', 48.9468951, 11.4232202, 0, 20],
  ['Berlin', 52.5327, 13.368151, 0, 20],
  ['Brandenburg',52.147052, 13.029619, 0, 20],
  ['Bremen', 53.112144339, 8.78623450, 0, 20],
  ['Hamburg', 53.554568183, 10.027208746, 0, 20],
  ['Hessen', 50.804256, 8.659773, 0, 20],
  ['Mecklenburg-Vorpommern', 53.7531202, 12.53758385, 0, 20],
  ['Niedersachsen', 52.661918, 9.468131, 0, 20],
  ['Nordrhein-Westfalen', 51.496297, 7.219533, 0, 20],
  ['Rheinland-Pfalz', 50.179671, 6.654691, 0, 20],
  ['Saarland',49.386627, 6.9570273, 0, 20],
  ['Sachsen-Anhalt', 51.843087, 11.056544, 0, 20],
  ['Sachsen', 51.155872, 13.303364, 0, 20],
  ['Schleswig-Holstein', 54.261276, 9.109166, 0, 20],
  ['Thüringen', 50.9029749, 11.0304845, 0, 20]
];

export default {
  germany,
  germanStates,
  berlin,
  thueringen
};
